/**
 * Image widths getCmsImageAttrs uses for Sanity image srcsets, picked the way next/image picked
 * deviceSizes/imageSizes (see getSrcSetWidths). Device sizes are for images about as wide as the screen,
 * image sizes for smaller images. next/image isn't used, so next.config.ts doesn't have these.
 */
export const DEVICE_SIZES: readonly number[] = [/*1640,*/ 1440, 768, 640, 555];
export const IMAGE_SIZES: readonly number[] = [256, 128, 64];
